/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit EditLetterAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Comms from './Comms/index'
import EditLetterModal from './EditLetterModal/index'
import LoadingSpinner from 'DesignSystem/LoadingSpinner/index'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function EditLetterAction({
  children,
  viewPath = "/DesignSystem/GenerateLettersModal/Content/Letters/Letter/Actions/EditLetterAction"
  
}) {
let letterValueData = fromData.useDataValue({ viewPath,
context: 'letter',
})
let selectedLoadingValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'loading',
})
let aggregateData = fromHelpers.isDisabled(letterValueData, selectedLoadingValueData)
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
let letterValueData1 = fromData.useDataFormat({ viewPath,
context: 'letter',
format: fromHelpers.getLabel,
})
let letterValueData2 = fromData.useDataValue({ viewPath,
context: 'letter',
})
let selectedLoadingValueData1 = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'loading',
})
let aggregateData1 = fromHelpers.isDisabled(letterValueData2, selectedLoadingValueData1)
let dtTypographyFontsizeMm = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontSize.mm'
        })
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let selectedLoadingValueData2 = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'loading',
})
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="ghost"
 cursor="pointer"
 paddingLeft={0}
 paddingRight={0}
 onClick={onClick}
 data="letter"
 data="selected.loading"
 aggregate="helpers.js isDisabled"
 disabled={aggregateData}
>
{childProps => (
<React.Fragment>
<TysiaText
{...childProps}
  viewPath={`${viewPath}/TysiaText`}
 fontSize={dtTypographyFontsizeMm}
 weight="medium"
 data={aggregateData1 ? "letter.is_finalized" : "letter"}
 format="helpers.js getLabel"
 text={letterValueData1}
 color={aggregateData1 ? dtColorsNeutral400 : dtColorsNeutral900}
 data={aggregateData1 ? "letter.is_finalized" : "letter"}
 data={aggregateData1 ? "letter.is_finalized" : "selected.loading"}
 aggregate="helpers.js isDisabled"
/>
<fromFlow.When is={selectedLoadingValueData2}>
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
 data="selected.loading"
 marginLeft={dtSpaceXxxs}
>
{childProps => (
<LoadingSpinner
{...childProps}
  viewPath={`${viewPath}/LoadingSpinner`}
 height={16}
 width={16}
/>
)}
</TysiaButtonIcon>
</fromFlow.When>
</React.Fragment>
)}
</TysiaButton>
<EditLetterModal
  viewPath={`${viewPath}/EditLetterModal`}
/>
<Comms
  viewPath={`${viewPath}/Comms`}
/>
{children}
</React.Fragment>)
}